// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.virtual-scroll-container[data-v-48d4d02e] {\n  height: 600px;\n  overflow-y: auto;\n  border: 1px solid #ddd;\n  margin: 10px 0;\n}\n.virtual-scroll-placeholder[data-v-48d4d02e] {\n  position: relative;\n}\n.virtual-scroll-content[data-v-48d4d02e] {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n", ""]);
// Exports
module.exports = exports;
